import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handler = (event) => this.onSubmitEnd(event)
    this.element.addEventListener("turbo:submit-end", this.handler)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handler)
  }

  onSubmitEnd(event) {
    if (!event.detail.success) return

    const btn = this.element.querySelector("[type='submit']")
    if (btn) {
      btn.classList.add("bet-pulse")
      btn.addEventListener("animationend", () => btn.classList.remove("bet-pulse"), { once: true })
    }

    this.spawnParticles()
  }

  spawnParticles() {
    const colors = ["#FFC107", "#FFB300", "#FF9800", "#FFE082"]
    const rect = this.element.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2

    for (let i = 0; i < 12; i++) {
      const particle = document.createElement("div")
      particle.className = "bet-particle"

      const angle = (Math.PI * 2 * i) / 12
      const distance = 40 + Math.random() * 60
      const dx = Math.cos(angle) * distance
      const dy = Math.sin(angle) * distance

      particle.style.cssText = `
        left: ${centerX}px;
        top: ${centerY}px;
        background: ${colors[i % colors.length]};
        --dx: ${dx}px;
        --dy: ${dy}px;
      `

      document.body.appendChild(particle)
      particle.addEventListener("animationend", () => particle.remove(), { once: true })
    }
  }
}
